export default __webpack_public_path__ + "resources/icons/n112-f1cc.png";